export function localStorageSpace() {
  let allStrings = ''
  for (let key in window.localStorage) {
    if (window.localStorage.hasOwnProperty(key)) {
      allStrings += window.localStorage[key]
    }
  }
  return allStrings ? (3 + ((allStrings.length * 16) / (8 * 1024))).toFixed(2) + ' KB' : '0 KB'
}
